/* ============================================================
   BEXFORD WATCHES — Shared JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── FAQ Accordion ──────────────────────────────────────── */
  document.querySelectorAll('.faq-item').forEach(item => {
    const btn = item.querySelector('.faq-question');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));
      if (!isOpen) item.classList.add('active');
    });
  });

  /* ── PDP Gallery ────────────────────────────────────────── */
  const mainImg = document.querySelector('.pdp-main img');
  document.querySelectorAll('.pdp-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = this.dataset.src || this.querySelector('img')?.src;
      document.querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ── Catalog Filter Tabs ────────────────────────────────── */
  const tabs = document.querySelectorAll('.filter-tab');
  const cards = document.querySelectorAll('.product-card[data-category]');
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const val = this.dataset.filter;
      cards.forEach(card => {
        card.style.display = (val === 'all' || card.dataset.category === val) ? '' : 'none';
      });
    });
  });

  /* ── Sticky header shadow on scroll ────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 2px 24px rgba(0,0,0,0.5)'
        : 'none';
    }, { passive: true });
  }

  /* ── Mobile nav toggle ──────────────────────────────────── */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
    });
  }

});
